import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DistributorIdFormatPipe } from "../../common/pipes/distributor-id-format.pipe";
import { CustomerService } from '../services/customer.service';
import { Subscription } from 'rxjs';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { CacheService } from '../../shared/services/cache.service';
import 'rxjs/add/operator/map';
import { Modal } from 'ngx-modal';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-member-documents',
  templateUrl: '../templates/template1/views/member-documents.component.html',
  styleUrls: [
    '../templates/template1/themes/default/css/member-documents.component.less'
  ],
  providers: [DistributorIdFormatPipe, DecimalPipe]

})
export class MemberDocumentsComponent implements OnInit {

  @Input() fboid: string;
  urlSafeEmbed: SafeResourceUrl;
  documentUrl: any[] = [];
  memberResponseUrl: any = {};
  blobFile: any;
  @ViewChild('previewImgModal') previewImgModal: Modal;
  imagePdf: any;
  frontImg: any;
  backImg: any;
  showBackImg:boolean;
  showFrontImg:boolean;

  constructor(
    private _formBuilder: FormBuilder, private _customerService: CustomerService, public sanitizer: DomSanitizer,
    private _cacheService: CacheService) {}

  ngOnInit(): void {
    this.getMemberDetails();
  }

  getMemberDetails() {
    this._customerService.getMemberDetails(this.fboid).subscribe((response) => {
      const resLength = response.memberDocuments.length;
      let j = 0;
      for (let i = 0; i < resLength; i++) {
        this.documentUrl[i] = response.memberDocuments[i];
        this.memberResponseUrl[i] = this.documentUrl[i];
        if (response.memberDocuments[i].frontSideURL) {
          this.showFrontImg = true;
          this.documentUrl[i].frontSideURL = response.memberDocuments[i].frontSideURL;
          this.memberResponseUrl[i].frontSideURL = this.documentUrl[i].frontSideURL;
          this.downloadImageFromUrl(this.documentUrl[i].frontSideURL).then(img => {
            this.frontImg = this.documentUrl[i].frontSideURL = img
            this.imagePdf = this.findFileExtentison(this.memberResponseUrl[i].frontSideURL) ? this.documentUrl[i].frontSideURL : '';
            if (!this.imagePdf) {
              this.imagePdf = this.documentUrl[i].frontSideURL;
            }
            this.documentUrl[i].frontSide = this.imagePdf;
            this.findFileExtentison(this.memberResponseUrl[i].frontSideURL) ? this.urlToFile(this.documentUrl[i].frontSideURL).then((image: any) => {
              this.frontImg = this.documentUrl[i].frontSideURL = image.img
            }) : '';
          });
        }
        else {
          this.showFrontImg = false;
          // this.documentUrl[i].frontSideURL = environment.uiTemplateBaseUrl + "/images/ind-default-image.png"
        }
        if (response.memberDocuments[i].backSideURL) {
          this.showBackImg = true;
          this.documentUrl[i].backSideURL = response.memberDocuments[i].backSideURL;
          this.memberResponseUrl[i].backSideURL = this.documentUrl[i].backSideURL;
          this.downloadImageFromUrl(this.documentUrl[i].backSideURL).then(img => {
            this.backImg = this.documentUrl[i].backSideURL = img
            this.imagePdf = this.findFileExtentison(this.memberResponseUrl[i].backSideURL) ? this.documentUrl[i].backSideURL : '';
            if (!this.imagePdf) {
              this.imagePdf = this.documentUrl[i].backSideURL;
            }
            this.documentUrl[i].backSide = this.imagePdf;
            this.findFileExtentison(this.memberResponseUrl[i].backSideURL) ? this.urlToFile(this.documentUrl[i].backSideURL).then((image: any) => {
              this.backImg = this.documentUrl[i].backSideURL = image.img
            }) : '';
          });
        }
        else {
          this.showBackImg = false;
        }
        if (response.memberDocuments[i].documentName) {
          this.documentUrl[i].documentName = response.memberDocuments[i].documentName;
        }
        j++;
      }
    });
  }

  async downloadImageFromUrl(imgUrl?: string | any) {
    const path = new URL(imgUrl).pathname.slice(1);
    const newres = await this._customerService.generateProfileImageSignedCDNURL(path).toPromise();
    const img = await newres.data[decodeURIComponent(path)];
    return img
  }

  closePreviewImg() {
    this.previewImgModal.close();
  }

  async urlToFile(fileLink) {
    let res = await fetch(fileLink);
    this.blobFile = await res.blob();
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      const pdfImgUrl = environment.uiTemplateBaseUrl + "/images/pdf.ico";
      reader.addEventListener("load", () => {
        if (this.blobFile.type == 'application/pdf') {
          const file = { 'img': pdfImgUrl, 'base64': reader.result }
          resolve(file);
        }
        else {
          resolve(reader.result);
        }
      }, false);
      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(this.blobFile);
    })
  }



  findFileExtentison(fileName) {
    if (fileName) {
      const fileExtension = fileName.split('.').pop();
      return (fileExtension.includes("pdf") ? true : false);
    }
  }

  uploadFromLoacl(imgUrl) {
    let img = imgUrl;
    if (imgUrl) {
      this.previewImgModal.open();
      this.imagePdf = imgUrl;
      this.urlSafeEmbed = this.sanitizer.bypassSecurityTrustResourceUrl(this.imagePdf + '#zoom=100&toolbar=0');
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/member-documents.component.ts